import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import { Group, OrganisationResponse } from 'api';
import OrganisationAutocomplete from 'components/OrganisationPicker/OrganisationAutocomplete';
import { TextV2 } from '@insights-ltd/design-library/components';
import OrganisationGroupLink from 'components/OrganisationGroupLink/OrganisationGroupLink';
import { Box, styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { SpecialHandlingChip } from 'components/SpecialHandlingTag';

const StyledDiv = styled('div')({});
const StyledGroupLink = styled(OrganisationGroupLink)({});

type SelectOrganisationProps = {
  selectedOrg?: OrganisationResponse;
  onSelect: (organisation: OrganisationResponse) => void;
  onChange?: () => void;
  isError?: boolean;
  errorText?: string;
  loading?: boolean;
  associatedGroup?: Group | undefined;
  disabled?: boolean;
  onlySpecialHandling?: boolean;
};

const SelectOrganisation = ({
  selectedOrg,
  associatedGroup,
  onSelect,
  onChange,
  isError,
  errorText,
  disabled,
  onlySpecialHandling = false,
}: SelectOrganisationProps) => {
  const { t } = useTranslation();

  return selectedOrg ? (
    <Card
      variant="outlined"
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '480px',
        padding: `1rem 1.25rem`,
        borderColor: theme.palette.grey[500],
      })}
      data-testid="select-org-card"
    >
      <Grid
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          borderColor: theme.palette.grey[500],
        })}
      >
        <StyledDiv
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <TextV2 variant="h3">{selectedOrg?.name}</TextV2>
          {associatedGroup ? (
            <StyledGroupLink
              sx={{ marginTop: '5px !important' }}
              group={associatedGroup}
              i18nKey="ui.event-management.teams.organisation.group"
            />
          ) : null}
        </StyledDiv>
        <Button
          sx={{
            minWidth: '100px !important',
            height: '48px',
            paddingLeft: '0',
            paddingRight: '0',
            visibility: disabled ? 'hidden' : 'visible',
          }}
          variant="outlined"
          onClick={onChange}
        >
          {t('ui.event-management.organisations.edit.select-group.change')}
        </Button>
      </Grid>
      <Box sx={{ marginTop: '1rem' }}>
        {selectedOrg?.visibility === 'PRIVATE' && <SpecialHandlingChip />}
      </Box>
    </Card>
  ) : (
    <OrganisationAutocomplete
      groupId={associatedGroup?.id}
      variant="dropdown"
      onSelect={onSelect}
      currentOrg={selectedOrg}
      disableClearable
      error={isError}
      helperText={isError ? errorText : undefined}
      disabled={disabled}
      onlySpecialHandling={onlySpecialHandling}
    />
  );
};

export default SelectOrganisation;
